<template>
	<section class="section-fl">
		<div class="section-container">
			<div class="fl-header">
				<h2>友情链接</h2>
				<p>行业权威机构与合作伙伴</p>
			</div>
			<div class="fl-grid">
				<div
					class="fl-card"
					v-for="fl in fls"
					:key="fl.title"
					@click="goLink(fl.href)"
				>
					<div class="fl-card-img">
						<el-image :src="fl.src" :title="fl.title" fit="contain"></el-image>
					</div>
					 <span class="fl-card-name">{{ fl.title }}</span>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			fls: [
				{
					src: require('@/assets/images/link/link-img01.png'),
					title: '国家市场监督管理总局',
					href: 'https://www.samr.gov.cn/'
				},
				{
					src: require('@/assets/images/link/link-img04.png'),
					title: '国家标准化管理委员会',
					href: 'https://www.sac.gov.cn/'
				},
				{
					src: require('@/assets/images/link/link-img03.png'),
					title: '中国特种设备检验研究院',
					href: 'https://www.csei.org.cn/'
				},
				{
					src: require('@/assets/images/link/link-img02.png'),
					title: '中国特种设备检验协会',
					href: 'https://www.casei.org.cn/'
				},
				{
					src: require('@/assets/images/link/link-img05.jpg'),
					title: '中国特种设备安全与节能促进会',
					href: 'http://www.cpase.org.cn/'
				},
				{
					src: require('@/assets/images/link/link-img06.jpg'),
					title: '全国锅炉压力容器标准化技术委员会',
					href: 'https://cscbpv.csei.org.cn/'
				},
				{
					src: require('@/assets/images/link/link-img07.jpg'),
					title: '中国计量大学',
					href: 'https://www.cjlu.edu.cn/'
				},
				{
					src: require('@/assets/images/link/link-img08.jpg'),
					title: '品读文化',
					href: 'https://mall.jd.com/index-11522401.html'
				}
			]
		};
	},
	methods: {
		goLink(href) {
			if (href) {
				window.open(href, '_blank');
			}
		}
	},
	components: {}
};
</script>

<style lang="less" scoped>
// ========== 友情链接 - 匹配首页整体风格 ==========
.section-fl {
	padding: 72px 0 80px;
}

.section-container {
	max-width: 1280px;
	margin: 0 auto;
	padding: 0 24px;
}

.fl-header {
	text-align: center;
	margin-bottom: 40px;

	h2 {
		font-size: 28px;
		font-weight: 700;
		color: #1e293b;
		margin: 0 0 12px;
	}

	p {
		font-size: 16px;
		color: #64748b;
		margin: 0;
	}
}

.fl-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 24px;
}

.fl-card {
	background: #ffffff;
	border-radius: 16px;
	padding: 0 20px;
	box-shadow: 0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04);
	border: 1px solid #f1f5f9;
	cursor: pointer;
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 25px rgba(0,0,0,0.1);
		border-color: #e2e8f0;

		.fl-card-name {
			color: #2563eb;
		}
	}
}

.fl-card-img {
	width: 100%;
	height: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-bottom: 24px;

	/deep/ .el-image {
		width: 100%;
		height: 100%;
	}

	/deep/ .el-image__inner {
		object-fit: contain;
	}
}

.fl-card-name {
	font-size: 14px;
	color: #64748b;
	text-align: center;
	font-weight: 500;
	line-height: 1.5;
	transition: color 0.2s;
	position: absolute;
	bottom: 12px;
}

// ========== 响应式 ==========
@media screen and (max-width: 767px) {
	.section-container {
		padding: 0 16px;
	}

	.section-fl {
		padding: 48px 0 56px;
	}

	.fl-header h2 {
		font-size: 24px;
	}

	.fl-grid {
		grid-template-columns: repeat(2, 1fr);
		gap: 16px;
	}

	.fl-card {
		padding: 20px 14px 16px;
		position: relative;
	}

	.fl-card-img {
		height: 80px;
	}
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
	.fl-grid {
		grid-template-columns: repeat(3, 1fr);
		gap: 20px;
	}
}
</style>
